<template>
  <section class="home">
    <div class="Loading" v-if="isPeriodLoading"> 
      {{ $t('UI.loading') }}
    </div>
    <template v-else>
    <div class="periodictable">
      <button class="item"
      v-for="el in  Elements.first" 
      :key="el.name_small"
      @click="openModal(el)"
      @mouseover="showElement(el)"
      :class="[`color-${el.group_id}`,{blur: blur&&blur!=el.group_id}]">
        <span class="small">{{ Math.floor(el.molar*10)/10 }}</span>
        {{ el.name_small }}
        <span class="el_number">{{ el.number }}</span>
      </button>
    </div>
     <div class="periodictable">
      <div class="elementinfo group" v-if="blur&&info.group_id&&info.group_id!=blur">
        <div class="title">
          <div class="sembol"
             :class="`color-${blur}`">
              {{ $t('types.'+blur) }}
          </div>
        </div>
      </div>
      <div class="elementinfo" v-else>
        <div class="title">
          <div class="sembol"
           :class="`color-${info.group_id}`">
            {{ info.name_small }}
          </div>
          <div class="name">
            <h3>{{ info['name_'+(lang=='en'?'ing':lang)] }}</h3>
            <span>{{ $t('types.'+info.group_id) }}</span>
          </div>
        </div>
        <div class="detail">
          <div class="d__item">
            <p class="info">{{ $t("element.number") }}</p>
            <P class="val" :class="`color-${info.group_id}`">{{ info.number }}</P>
          </div>
           <div class="d__item">
            <p class="info">{{ $t("element.molar") }}</p>
            <P class="val" :class="`color-${info.group_id}`">{{ Math.floor(info.molar*20)/20 }} 
              <span>g/mol</span>
            </P>
          </div>
        </div>
      </div>
      <button 
      type="button"
      class="item"
      v-for="el in  Elements.second" 
      :key="el.name_small"
      @click="openModal(el)"
      @mouseover="showElement(el)"
      :class="[{'second': el.column === 1, blur: blur&&blur!=el.group_id }, `color-${el.group_id}`]">
        <span class="small">{{ Math.floor(el.molar*10)/10 }}</span>
        {{ el.name_small }}
        <span class="el_number">{{ el.number }}</span>
      </button>
     </div>
     <div class="periodictable">
        <button 
        type="button"
        class="item"
        @click="openModal(el)"  
        @mouseover="showElement(el)"
        v-for="el in  Elements.body" 
        :key="el.name_small"
        :class="[{blur: blur&&blur!=el.group_id }, `color-${el.group_id}`]">
          <span class="small">{{ el.molar?Math.floor(el.molar*10)/10:'' }}</span>
          {{ el.name_small }}
          <span class="el_number">{{ el.number }}</span>
        </button>
     </div>
     <div class="periodictable p-footer">
        <button 
        type="button"
        class="item" 
        v-for="el in  Elements.bottom"
        @click="openModal(el)"
        @mouseover="showElement(el)"
        :key="el.name_small"
        :class="[{'x2' : el.column === 2, 'x': el.column === 16 ,blur: blur&&blur!=el.group_id}, `color-${el.group_id}`]">
          <span class="small">{{ Math.floor(el.molar*10)/10 }}</span>
          {{ el.name_small }}
          <span class="el_number">{{ el.number }}</span>
        </button>
     </div>
    </template>
    <footer class="footer" v-if="!isPeriodLoading">
      <div class="text">
       <h3>{{ $t("UI.name") }}</h3>
      </div>
      <div class="description" @mouseleave="!blurset?blur=null:null">
        <div v-for="i in 10" 
            :key="$t('types.' + i)"
            class="item"
            @mouseover="!blurset?blurOthers(i):null"
            @click="(blurOthers(i));(blurset=blurset?0:1)"
            :class="['color-' + i,{blur:blur&&blur!=i,set:blurset}]">
            {{ $t("types."+i) }}
        </div>
      </div>
      <div class="end">
        <div class="github">
          <a href="https://github.com/alpeer/duzenli-cizelge" target="_blank">
            <!-- Generated by IcoMoon.io -->
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
            <path fill="currentColor" d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z"></path>
            </svg>
            {{$t('UI.star')}}
          </a>
       </div>
       <div class="text"> 
        {{ $t('UI.name') }} (v.0.3) By 
        <a href="https://github.com/edisdev" target="_blank">#edisdev</a>
        -
        <a href="https://github.com/alpeer" target="_blank">@alpeer</a>
       </div>
       <button class="checkbox" 
        @click="openDarkMode" 
        :class="{'dark-active': darkMode}"
        type="button">
          
       </button>
       <label  @click="openDarkMode">{{ $t('UI.mode.'+ (darkMode?'dark':'light')) }}</label>
       <button class="checkbox lang" 
        @click="langSwitch" 
        :class="{[lang]:1}"
        type="button">
        <svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 512 512">
          <g class="tr" v-if="lang=='tr'">
            <path fill="#ed1f34" d="M473 372a35 35 0 0 0 1-4v-1-2-215a34 34 0 0 0-17-30l-22-13-22-13-17-9-66-39-26-14-19-12-12-6c-11-6-24-6-34 0l-12 6-19 12-26 14-66 39-29 16-21 13-11 6a34 34 0 0 0-17 30v218a35 35 0 0 0 1 4l4 9 4 5 2 2 1 1a33 33 0 0 0 5 3l22 13 22 12 17 10 92 53 19 12 12 6c11 6 24 6 34 0l12-6 19-12 26-14 55-33 11-6 26-15 22-12 13-8a34 34 0 0 0 5-3l1-1 2-2c4-4 6-9 8-14z"/><g fill="#fff"><path d="M207 327a71 71 0 1 1 50-122 96 96 0 1 0 0 102 71 71 0 0 1-50 20zM265 256l28-11 2-30 19 24 29-8-17 25 17 25-29-8-19 24-2-30z"/><path d="M265 256l28-11 2-30 19 24 29-8-17 25 17 25-29-8-19 24-2-30z"/></g><path d="M349 227c-2-3-5-4-8-3l-24 7-16-20a7 7 0 0 0-13 4l-1 25-24 9a7 7 0 0 0 0 14l24 9 1 25a7 7 0 0 0 13 4l16-20 24 7a7 7 0 0 0 8-11l-14-21 14-21v-8zm-29 33l7 9-11-3c-3 0-6 1-8 3l-7 9v-12c-1-2-2-5-5-6l-10-4 10-4c3-1 4-4 5-6v-12l7 9c2 2 5 3 8 3l11-3-7 9v8zm-57 50a103 103 0 1 1 0-109 7 7 0 0 1-11 9 64 64 0 0 0-107 33 7 7 0 0 1-15-3 78 78 0 0 1 89-61 89 89 0 0 0-133 77 89 89 0 0 0 133 77l-12 1c-37 0-69-26-77-62a7 7 0 1 1 14-3 64 64 0 0 0 108 33 7 7 0 0 1 11 8zm220-160a43 43 0 0 0-21-38L277 6a43 43 0 0 0-43 0L50 112a43 43 0 0 0-18 21c-2 5-3 11-3 17v212a43 43 0 0 0 0 4v3a44 44 0 0 0 1 5v1l5 11 5 6h1l2 3h1a43 43 0 0 0 6 5l185 106c6 4 13 6 21 6s15-2 22-6l184-106a42 42 0 0 0 6-5h1l2-3h1c4-5 8-11 10-17v-1-2l1-1v-2a37 37 0 0 0 0-3 21 21 0 0 0 0-4V150zm-18 214v4l-1 1v1a26 26 0 0 1-8 12 25 25 0 0 1-3 2L269 491a25 25 0 0 1-25 0L59 384a25 25 0 0 1-3-2l-1-1a25 25 0 0 1-7-11v-1l-1-1v-2-2-214a25 25 0 0 1 12-22L243 21a25 25 0 0 1 25 0l185 107a25 25 0 0 1 12 22v214z"/></g>
            <g class="en" v-else><path fill="#103b9b" d="M473 372a33 33 0 0 0 1-4v-1-2-216a34 34 0 0 0-17-29l-22-13-22-13-17-9-66-39-26-14-19-12-12-6c-11-6-24-6-34 0l-12 6-19 12-26 14-66 39-29 16-21 13-11 6a34 34 0 0 0-15 17c-2 4-2 8-2 13v220l1 2 4 9 4 5 2 2 1 1a33 33 0 0 0 5 3l22 13 22 12 17 10 92 53 19 12 12 6c11 6 24 6 34 0l12-6 19-12 26-14 56-33 10-6 26-15 22-12 13-8a34 34 0 0 0 5-3l1-1 2-2c4-4 6-9 8-14z"/><path fill="#fff" d="M473 141a34 34 0 0 0-16-21l-22-13-22-13-157 105L99 94l-12 7-21 13-11 6a34 34 0 0 0-15 17c-2 4-2 8-2 13v17l133 89-133 89v23a33 33 0 0 0 1 4 34 34 0 0 0 4 9l4 5 2 2 1 1a33 33 0 0 0 5 3l22 13 22 12 157-104 157 104 9-5 22-12 13-8a34 34 0 0 0 5-3l1-1 2-2c4-4 6-9 8-14a33 33 0 0 0 1-4v-1-2-20l-133-89 133-89v-18l-1-8z"/><path fill="#ed1f34" d="M462 389l1-1 2-2c4-4 6-9 8-14a33 33 0 0 0 1-4v-1-2-1L284 237l174-116-1-1-22-13-7-4-200 134L54 121l-2 1a34 34 0 0 0-14 26l189 127L53 391l2 1 22 13 6 4 201-134 175 116 1-1 2-1z"/><path d="M457 392l-6 4-167-111L92 413l-15-8-2-1 205-137c2-2 6-2 9 0l177 118-1 1-2 2-1 1a34 34 0 0 1-5 3zM236 275c0-3-1-6-4-7L39 139l-1 11v9l174 116L46 385l1 1 2 2 1 1a33 33 0 0 0 5 3l6 4 171-114c3-1 4-4 4-7zm-8-29l4-2 205-136-2-1-15-9-192 128L62 116l-7 4a34 34 0 0 0-8 7l176 117 5 2zm47-9c0 3 2 6 4 7l194 130v-2a33 33 0 0 0 1-4v-1-2-11L300 237l166-110a34 34 0 0 0-9-7l-7-4-171 114c-2 1-4 4-4 7z"/><path fill="#fff" d="M474 295v-87H303V31l-18-11-12-6c-11-6-24-6-34 0l-12 6-18 11v177H38v95h171v178l18 11 12 6c11 6 24 6 34 0l12-6 18-11V303h171v-8z"/><path fill="#ed1f34" d="M474 230H281V18l-8-4c-11-6-24-6-34 0l-8 4v212H38v51h193v213l8 4c11 6 24 6 34 0l8-4V281h193v-51z"/><path d="M483 149a43 43 0 0 0-21-37L278 6c-14-8-30-8-44 0L50 112a43 43 0 0 0-18 21c-2 5-4 11-4 17l1 213a42 42 0 0 0 0 3 43 43 0 0 0 6 20 43 43 0 0 0 8 9h1a43 43 0 0 0 6 5l184 106a43 43 0 0 0 44 0l184-106a43 43 0 0 0 6-5h1l2-3h1a43 43 0 0 0 11-26 24 24 0 0 0 1-4l-1-213zm-28-20a25 25 0 0 1 10 20v72H291V35l162 93 2 1zM48 140a25 25 0 0 1 11-12l162-93v186H47v-71l1-10zm9 243l-1-1-1-1-1-1-3-4-3-6v-1l-1-1v-2-2-73h174v186L59 384l-2-1zm408-19v4a25 25 0 0 1-1 1v1a26 26 0 0 1-8 12 26 26 0 0 1-3 2l-162 93V291h106a9 9 0 1 0 0-18H282c-5 0-9 4-9 9v206l-4 3c-8 4-18 4-25 0l-5-3V282c0-5-4-9-9-9H47v-34h183c5 0 9-4 9-9V24l4-3c8-4 18-4 25 0l5 3v206c0 5 4 9 9 9h183v34h-27a9 9 0 1 0 0 18h27v73z"/>
          </g>
        </svg>
        </button>
        <label @click="langSwitch">{{ $t('UI.lang.'+lang)}}</label>

      </div>
    </footer>
    <modal :element="ModalData"
           v-if="showModal"
           @closeModal="closeModal"/>
  </section>
</template>

<script>
import Modal from './modal';
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: "PeriodicTable",
  data() {
    return {
      blur: null,
      blurset:false,
      showModal: false,
      ModalData: [],
      info: {}
    };
  },
  components: {
    Modal
  },
  computed: {
   ...mapGetters([ 'Elements', 'isPeriodLoading', 'darkMode', 'lang'])
  },
  methods: {
    ...mapActions(['getElements']),
    ...mapMutations(['TOGGLE_DARK_MODE','LANG_SWITCH']),
    openModal(element) {
      if (element.number === '57-71' || element.number === '89-103') {
        return
      }
      this.ModalData = element
      this.info = element
      this.showModal = true
    },
    closeModal() {
      this.ModalData = []
      this.showModal = false
    },
    showElement(element) {
      if (element.number === '57-71' || element.number === '89-103') {
        return
      }
      this.info = element
    },
    blurOthers(group) {
      this.blur = group
    },
    openDarkMode() {
      this.TOGGLE_DARK_MODE()
    },
    langSwitch() {
      this.LANG_SWITCH()
    }
  },
  async mounted() {
    await this.getElements();
  }
}
</script>


<style lang="scss">
@import '@/assets/config/variable.scss';

.home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  padding: 20px;
}

.elementinfo {
  position: absolute;
  left: calc(((#{$element-size} + .46vw) * 2) + .3vw);
  bottom: 0;
  width: calc(((#{$element-size} + .46vw) * 10) - .3vw);
  display: flex;
  z-index: 999;
  flex-direction: column;
  background: transparent;
  color: #000;
  &.group{
    .title {
      font-size: 2em;
      .sembol {
        width: 100%;
        background: transparent;
      }
    }
    padding: 20px;
  }
  .title {
    display: flex;
    margin-left: 1rem;
    .name {
      padding: 1rem;
      h3 {
        font-weight: 500;
        font-size: 1.5rem;
        line-height: 1.1;
        margin-bottom: .7rem;
      }
      span {
        opacity: .4;
        font-size: .9rem;
      }
    }
    .sembol {
      background: #35404d;
      color: #fff;
      width: 5rem;
      height: 5rem;
      display: flex;
      font-size: 3vw;
      align-items: center;
      justify-content: center;
      &.color-1 {
        color:$non-matel;
        border-bottom: .4rem solid $non-matel;
      }
      &.color-2 {
        color:$alkal-metal;
        border-bottom: .4rem solid $alkal-metal;
      }
      &.color-3 {
        color:$alkaline-metal;
        border-bottom: .4rem solid $alkaline-metal;
      }
      &.color-4 {
        color:$transition-metal;
        border-bottom: .4rem solid  $transition-metal;
      }
      &.color-5 {
        color:$metaloid;
        border-bottom: .4rem solid $metaloid;
      }
      &.color-6 {
        color:$metal;
        border-bottom: .4rem solid $metal;
      }
      &.color-7 {
        color:$halojen;
        border-bottom: .4rem solid $halojen;
      }
      &.color-8 {
        color:$soygaz;
        border-bottom: .4rem solid $soygaz;
      }
      &.color-9 {
        color:$lantanit;
        border-bottom: .4rem solid $lantanit;
      }
      &.color-10 {
        color:$actinide;
        border-bottom: .4rem solid $actinide;
      }
    }
  }
  .detail {
    display: flex;
    width: 100%;
    margin-top: 20px;
    .d__item {
      width: 50%;
      padding: 10px;
      font-weight: 500;
      .info {
        opacity: .5;
      }
      .val {
        &.color-1 {
          color: $non-matel;
        }
        &.color-2 {
          color: $alkal-metal;
        }

        &.color-3 {
          color: $alkaline-metal;
        }

        &.color-4 {
          color: $transition-metal;
        }

        &.color-5 {
          color: $metaloid;
        }

        &.color-6 {
          color: $metal;
        }

        &.color-7 {
          color: $halojen;
        }

        &.color-8 {
          color: $soygaz;
        }

        &.color-9 {
          color: $lantanit;
        }

        &.color-10 {
          color: $actinide;
        }
      }
    }
  }
}

.periodictable {
  width: 75vw;
  display: flex;
  flex-wrap: wrap;
  max-width: 100vw;
  position: relative;
  justify-content: space-between;
  &.title {
    margin-bottom: 50px;
    justify-content: center;
    transform: translateX(-10%);
  }
  .item {
    width: $element-size;
    height: $element-size;
    margin: .23vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-shadow: 0;
    border: 0;
    cursor: pointer;
    font-size: 1vw;
    font-weight: bold;
    position: relative;
    color: #fff;
    transform-origin: center;
    opacity: 1;
    .el_number {
      display: block;
      font-size: 50%;
      margin-top: 5px;
      opacity: .5;
    }
    &.blur{
      opacity:.1
    }
  }
}

.description {
  width: 100%;
  flex-shrink: 0;
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 1vw;
    &.blur{
      opacity:.5;
      &.set{
        text-decoration:line-through;
      }
    }
    &::before {
      content: '';
      display: inline-block;
      width: 30px;
      height: 20px;
      margin-right: 5px;
    }
    &.color-1::before {
      background: $non-matel;
    }
    &.color-2::before {
      background: $alkal-metal;
    }
    &.color-3::before {
      background: $alkaline-metal;
    }
    &.color-4::before {
      background: $transition-metal;
    }
    &.color-5::before {
      background: $metaloid;
    }
    &.color-6::before {
      background: $metal;
    }
    &.color-7::before {
      background: $halojen;
    }
    &.color-8::before {
      background: $soygaz;
    }
    &.color-9::before {
      background: $lantanit;
    }
    &.color-10::before {
      background: $actinide;
    }
  }
}

/* //  */

.periodictable {
  .item {
    .small {
      font-size: 50%;
      opacity: .5;
    }
    &.color-1 {
      background: rgba($non-matel, 0.9);
      border: 1px solid $non-matel;
    }
    &.color-2 {
      background: rgba($alkal-metal, 0.9);
      border: 1px solid $alkal-metal;
    }
    &.color-3 {
      background: rgba($alkaline-metal, 0.9);
      border: 1px solid $alkaline-metal;
    }
    &.color-4 {
      background: rgba($transition-metal, 0.9);
      border: 1px solid  $transition-metal;
    }
    &.color-5 {
      background: rgba($metaloid, 0.9);
      border: 1px solid $metaloid;
    }
    &.color-6 {
      background: rgba($metal, 0.9);
      border: 1px solid $metal;
    }
    &.color-7 {
      background: rgba($halojen, 0.9);
      border: 1px solid $halojen;
    }
    &.color-8 {
      background: rgba($soygaz, 0.9);
       border: 1px solid $soygaz;
    }
    &.color-9 {
      background: rgba($lantanit, 0.9);
      border: 1px solid $lantanit;
    }
    &.color-10 {
      background: rgba($actinide, 0.9);
      border: 1px solid $actinide;
    }

    &:hover {
      background: #323232 !important;
      border-color: #000 !important;
    }
    &.second {
      margin-right: calc(((#{$element-size} + 0.46vw) * 10) + 0.69vw);
    }
  }
  &.p-footer {
    margin-top: 20px;
    .item {
      &.x2 {
        margin-left: calc((#{$element-size} +  0.46vw) * 2);
      }
      &.x {
        margin-right: calc((#{$element-size} +  0.46vw));
      }
    }
  }
}

.checkbox {
  width: 70px;
  height: 30px;
  background: #fff;
  border-radius: 30px;
  position: relative;
  margin-bottom: 10px;
  margin-top: 20px;
  cursor: pointer;
  transition: .3s all ease;
  color: inherit;
  border: 1.4px solid #000;
  &.lang{
    height:70px;
    background:transparent;
    border:none;

    &::after{
      display:none
    }
  }
  &::after {
    content: '';
    display: flex;
    width: 20px;
    height: 20px;
    background: #000;
    position: absolute;
    left: 5px;
    top: 3px;
    border-radius: 50%;
  }
  &.dark-active {
    background: #000;
    border: 1.4px solid #fff;
    &::after {
      background: #fff;
      right: 5px;
      left: initial;
    }
  }
  label {
    position: absolute;
    right: calc(-100% - 10px);
    top: 4px;
    font-size: 13px;
    font-weight: 600;
  }
}

.footer {
  display: flex;
  color: inherit;
  position: fixed;
  flex-wrap: wrap;
  align-items: center;
  width: calc(25vw - 30px);
  height: 100vh;
  right: 0;
  top: 0;
  padding: 20px;
  box-shadow: -2px 5px 10px rgba(#000, .3);
  h3 {
    font-size: 2vw;
    line-height: 50px;
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: currentColor;
      opacity: 0.2;
    }
  }
  .end {
    flex-shrink: 0;
    width: 100%;
    align-self: flex-end;
    display: grid;
    grid-template-rows: auto auto auto auto;
    grid-template-columns: 80px auto;

    .checkbox {
      margin: 5px 0;
    }
    label {
      display: flex;
      align-items: center;
    }
  }
  .text {
    font-size: 15px;
    grid-area:1 span/2 span/2;
    a {
      color: inherit;
      font-weight: bold;
    }
  }
}
.github {
  grid-area:1 span/2 span/1;
  width: 100%;
  a {
    background: #323232;
    color: #fff;
    width: 100%;
    display: flex;
    padding: 9px;
    font-size: 14px;
    border-radius: 3px;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    margin-bottom: 30px;
    font-weight: 500;
    svg {
      margin-right: 5px;
    }
  }
}

//  --------- //

.darkMode {
  .periodictable {
    .item {
      &.color-1 {
        background: rgba($non-metal-dark, 0.25);
        border: 1px solid $non-metal-dark;
      }
      &.color-2 {
        background: rgba($alkal-metal-dark, 0.25);
        border: 1px solid $alkal-metal-dark
      }
      &.color-3 {
        background: rgba($alkaline-metal-dark, 0.25);
        border: 1px solid $alkaline-metal-dark;
      }
      &.color-4 {
        background: rgba($transition-metal-dark, 0.25);
        border: 1px solid $transition-metal-dark;
      }
      
      &.color-5 {
        background: rgba($metaloid-dark, 0.25);
        border: 1px solid $metaloid-dark
      }
      
      &.color-6 {
        background: rgba($metal-dark, 0.25);
        border: 1px solid $metal-dark
      }
      &.color-7 {
        background: rgba($halojen-dark, 0.25);
        border: 1px solid $halojen-dark
      }
      &.color-8 {
        background: rgba($soygaz-dark, 0.25);
        border: 1px solid $soygaz-dark
      }
      &.color-9 {
        background: rgba($lantanit-dark, 0.25);
        border: 1px solid $lantanit-dark;
      }
      &.color-10 {
        background: rgba($actinide-dark, 0.25);
        border: 1px solid $lantanit-dark
      }
    }
  }
  .description {
    .item {
      &.color-1::before {
        background: $non-metal-dark;
      }
      &.color-2::before {
        background: $alkal-metal-dark;
      }
      &.color-3::before {
        background: $alkaline-metal-dark;
      }
      &.color-4::before {
        background: $transition-metal-dark;
      }
      &.color-5::before {
        background: $metaloid-dark;
      }
      &.color-6::before {
        background: $metal-dark;
      }
      &.color-7::before {
        background: $halojen-dark;
      }
      &.color-8::before {
        background: $soygaz-dark;
      }
      &.color-9::before {
        background: $lantanit-dark;
      }
      &.color-10::before {
        background: $actinide-dark;
      }
    }
  }
  .footer {
    background: #1e2f38;
  }
  .github {
    a {
      background: #eee;
      color: #000;
    }
  }

  .elementinfo {
    color: #fff;
    .sembol {
      &.color-1 {
        color:$non-metal-dark;
        border-bottom: .4rem solid $non-metal-dark;
      }
      &.color-2 {
        color:$alkal-metal-dark;
        border-bottom: .4rem solid $alkal-metal-dark;
      }
      &.color-3 {
        color:$alkaline-metal-dark;
        border-bottom: .4rem solid $alkaline-metal-dark;
      }
      &.color-4 {
        color:$transition-metal-dark;
        border-bottom: .4rem solid $transition-metal-dark;
      }
      &.color-5 {
        color:$metaloid-dark;
        border-bottom: .4rem solid $metaloid-dark;
      }
      &.color-6 {
        color:$metal-dark;
        border-bottom: .4rem solid $metal-dark;
      }
      &.color-7 {
        color:$halojen-dark;
        border-bottom: .4rem solid $halojen-dark;
      }
      &.color-8 {
        color:$soygaz-dark;
        border-bottom: .4rem solid $soygaz-dark;
      }
      &.color-9 {
        color: $lantanit-dark;
        border-bottom: .4rem solid $lantanit-dark;
      }
      &.color-10 {
        color: $actinide-dark;
        border-bottom: .4rem solid $actinide-dark;
      }
    }
    .detail {
      .val {
        &.color-1 {
          color: $non-metal-dark;
        }
        &.color-2 {
          color: $alkal-metal-dark;
        }

        &.color-3 {
          color: $alkaline-metal-dark;
        }

        &.color-4 {
          color: $transition-metal-dark;
        }

        &.color-5 {
          color: $metaloid-dark;
        }

        &.color-6 {
          color: $metal-dark;
        }

        &.color-7 {
          color: $halojen-dark;
        }

        &.color-8 {
          color: $soygaz-dark;
        }

        &.color-9 {
          color: $lantanit-dark;
        }

        &.color-10 {
          color: $actinide-dark;
        }
      }
    }
  }

}
</style>
